<template>
  <div class="bedrijfsbeheer">
    <v-container fluid class="mt-12 pa-0 pt-6" >
      <v-container class="max-container mx-auto py-12 my-12" :class="[$vuetify.breakpoint.smAndDown ? 'pt-0' : 'py-12 my-12']">
        <v-layout row wrap px-4>
          <v-flex xs12>
            <s-card :title="pageContent.pageSub1">
               <v-dialog v-model="addDialog"  max-width="500" dark black>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary" to="" class="text-none mt-4 mb-2"
                      v-html="'Toevoegen'"

                      v-on="on"
                    >
                    </v-btn>
                  </template>
                    <s-card  :cardcolor="pageContent.cardColor">
                      <span class=" d-block headline white--text mt-4 " :class="[$vuetify.breakpoint.mdAndUp ? 'mb-0 px-3 ' : 'px-5 mb-2']">
                        Bedrijf toevoegen of aanpassen
                      </span>
                      <form >
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <span class="font-weight-bold white--text d-block">Bedrijf</span>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field dark
                                prepend-icon="fas fa-building"
                                name="companyName"
                                ref="companyName"
                                label="Bedrijfsnaam"
                                type="text"
                                class="my-0"
                                v-model="company"
                                :error-messages="errors.name"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field dark
                                prepend-icon="fas fa-network-wired"
                                name="max"
                                label="Maximum adressen (leeg for geen)"
                                class="my-0"
                                v-model="max"
                                :error-messages="errors.max"
                                type="number"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" class="pb-0">
                              <v-checkbox dark color="primary" class="my-0"
                                v-model="metercode"
                                label="Metercode is optioneel"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                          <v-divider dark class="mb-2"></v-divider>
                          <v-row v-if="edit_id == undefined">
                            <v-col cols="12" sm="6">
                              <span class="font-weight-bold white--text d-block">Gebruiker</span>
                            </v-col>
                          </v-row>
                          <v-row v-if="edit_id == undefined">
                            <v-col cols="12" sm="6">
                              <v-text-field dark
                                prepend-icon="fas fa-user"
                                name="username"
                                label="Naam"
                                type="text"
                                class="my-0"
                                v-model="user"
                                :error-messages="errors.user"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field dark
                                prepend-icon="email"
                                name="email"
                                label="E-mail adres"
                                type="text"
                                class="my-0"
                                v-model="email"
                                :error-messages="errors.email"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions class="pa-3 grey darken-2">
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary" to="" class="text-none"
                            v-html="'Opslaan'"
                            @click="storeComapny"
                          >
                          </v-btn>
                          <v-btn
                            color="primary" to="" class="text-none"
                            v-html="'Annuleren'"
                            @click="cancelEdit"
                          >
                          </v-btn>
                        </v-card-actions>
                      </form>
                    </s-card>
                    <v-dialog v-model="company_added" max-width="500" light>
                      <v-card class="pa-4">
                        <h3 class=" title primary--text pa-3">
                          Het bedrijf is toegevoegd
                        </h3>
                        <v-card-text>
                          {{ company_added_text }}<br />
                          Het certificaat wachtwoord is: {{ company_added_password }}<br />
                          <a v-bind:href="company_added_url" target="blank">klik hier om het certificaat te downloaden</a>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                            color="primary" to="" class="text-none"
                            @click="company_added = false; company_added_text = company_add_password = company_added_url = ''"
                            >
                            Ok
                            </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                </v-dialog>
                <v-dialog v-model="remove_company" max-width="500" light>
                  <v-card class="pa-4">
                    <v-card-text>
                      Weet je zeker dat je {{ remove_name }} wilt verwijderen
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary" to="" class="text-none"
                        @click="company_remove"
                      >
                        Ja
                      </v-btn>
                      <v-btn
                        color="primary" to="" class="text-none"
                        @click="remove_name = remove_id = ''; remove_company = false;"
                      >
                        Nee
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                      <v-snackbar
                        v-model="snackbar"
                        :timeout="timeout"
                        :color="color"
                      >
                        {{ text }}
                        <v-icon class="white--text">{{ icon }}</v-icon>
                      </v-snackbar>
              <v-data-table dark
                :headers="headers"
                :items="tablecontent"
                :items-per-page="25"
                class="elevation-0 big-headers mt-4 transparent dark-table p4-table"
                :footer-props="{ itemsPerPageOptions: [25,50,75,100], itemsPerPageText: 'Rijen per pagina' }"
                :class="[$vuetify.breakpoint.mdAndUp ? 'white-borders' : 'mobile-table']"
                dense
                :server-items-length="tablecount"
                :loading="loading"
                loading-text="laden..."
                :options.sync="options"
              >
                <template v-slot:item.actions="{ item }">
                  <span class="text-no-wrap">
                    <!--<v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span class="text-no-wrap" v-on="on">
                          <a style="text-decoration: none !important" href="#"><v-icon class="mr-2">insert_drive_file</v-icon></a>
                        </span>
                      </template>
                      <span>Certificaat hermaken</span>
                    </v-tooltip>-->
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span class="text-no-wrap" v-on="on">
                          <a style="text-decoration: none !important" @click="editCompany(item)"><v-icon class="mr-2">edit</v-icon></a>
                        </span>
                      </template>
                      <span>Bewerken</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span class="text-no-wrap" v-on="on">
                          <a style="text-decoration: none !important" @click="removeCompany(item.id, item.name)"><v-icon class="mr-2">delete</v-icon></a>
                        </span>
                      </template>
                      <span>Verwijderen</span>
                    </v-tooltip>
                  </span>
                </template>
                <template slot="body.append">
                <tr v-if="$vuetify.breakpoint.smAndUp">
                  <td><v-text-field v-model="options.filters.name" dark label="naam"></v-text-field></td>
                  <td></td>
                  <td><v-select v-model="options.filters.code_required" :items="required" dark label="metercode verplicht" style="width:160px;"></v-select></td>
                  <td></td>
                </tr>
                </template>
              </v-data-table>
            </s-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
  </div>
</template>

<script>

export default {

  name: 'bedrijfsbeheer',
  data() {
    return {
      addDialog: false,
      snackbar: false,
      text: 'Succesvol opgeslagen',
      color: 'primary',
      icon: 'error',
      timeout: 3000,
      company: '',
      max: '',
      user: '',
      email: '',
      metercode: false,
      company_added: false,
      company_added_text: '',
      company_added_password: '',
      company_added_url: '',
      dialog: false,
      netbeheerder: 'Stedin',
      netbeheerders: [
        { text: 'Stedin' },
        { text: 'Eneco' },
      ],
      required: [
        { text: 'Allemaal', value: null },
        { text: 'Ja', value: 1 },
        { text: 'Nee', value: 0 },
      ],
      chips: [],
      items: ['Item 1', 'Item 2'],

      pageContent: {
        pageTitle: 'Bedrijfsbeheer',
        pageSub1: 'Alle bedrijven',
        pageSub2: 'Bedrijf toevoegen of aanpassen',
        cardColor: 'grey darken-3',
      },
      headers: [
        { text: 'Naam', value: 'name', align: 'left' },
        { text: 'Huidig/max', value: 'state' },
        { text: 'Meter code verplicht', value: 'code_required' },
        { text: 'Acties', value: 'actions', sortable: false },
      ],
      tablecontent: [],
  	  tablecount: 0,
  	  options: { filters:{} },
  	  errors: {},
  	  loading: false,
  	  remove_name:'',
  	  remove_id:'',
  	  remove_company:false,
  	   edit_id: undefined,
      };
  },
  methods: {
    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1);
      this.chips = [...this.chips];
    },
	loadData()
	{
		let self = this;
		self.loading = true;
		this.$store.dispatch('LoadCompanies', this.options).then
		((data) => {
			self.tablecount = data.recordsFiltered;
			self.tablecontent = data.data;
			self.loading = false;
		});
	},
	storeComapny()
	{
		let data =
		{
			name:this.company,
			max:this.max,
			code_required:!this.metercode,
		}
		if(this.edit_id == undefined)
		{
			data.user = this.user;
			data.email = this.email;
		}
		else
		{
			data.id = this.edit_id;
		}
		this.$store.dispatch('addCompany', data).then
		((data) => {
			if(this.edit_id == undefined)
			{
				this.company_added_text = data.message;
				this.company_added_password = data.result.password;
				this.company_added_url= data.result.file;
				this.company_added = true;
			}
			else
			{
				this.text = data.message;
				this.color = 'primary';
				this.icon = 'check_circle'
				this.snackbar = true;
			}
			this.cancelEdit();
			this.loadData();
		}).catch(
		(errors) => {
			this.errors = errors.errors;
		});
	},
	removeCompany(companyId, name)
	{
		this.remove_id = companyId;
		this.remove_name = name;
		this.remove_company = true;
	},
	company_remove()
	{
		this.$store.dispatch('removeCompany', this.remove_id).then
		((data) => {
			this.remove_id = this.remove_name = '';
			this.remove_company = false;
			this.loadData();
			this.text = data.message;
			this.color = 'primary';
			this.icon = 'check_circle'
			this.snackbar = true;
		}).catch(
		(errors) => {
			this.remove_id = this.remove_name = '';
			this.remove_company = false;
			this.text = errors.errors.pop();
			this.color = 'error';
			this.icon = 'error'
			this.snackbar = true;
		});
	},
	editCompany(company)
	{
		this.edit_id = company.id;
		this.company = company.name;
		this.max = company.max;
		this.metercode = !company.code;
		this.addDialog = true;
	},
	cancelEdit()
	{
		this.edit_id = undefined;
		this.company = '';
		this.max = '';
		this.user = '';
		this.email = '';
		this.metercode = false;
		this.addDialog = false;
	}
  },
  watch:
  {
	options: {
		deep: true,
        handler () {
			this.loadData();
		}
	},
	company: {handler () { this.errors.name = undefined; }},
	max: {handler () { this.errors.max = undefined; }},
	user: {handler () { this.errors.user = undefined; }},
	email: {handler () { this.errors.email = undefined; }},
  },
  created()
  {
	if(this.$store.getters.auth === false){
		this.$router.push({name: 'authentication'});
		return;
	}
	let self = this;
	this.$store.dispatch('LoadOperators', this.options).then
	((data) => {
		self.operators = data.operators;
	});
  },
};
</script>
